import React, { useState, useEffect } from "react";

import { useParams } from "react-router-dom";

import { Formik, Form, Field } from "formik";
import { ToastContainer } from "react-toastify";
import { message, Pagination, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import Loadar from "../../common/loader/Loader";
import CustomInputField from "../../common/CustomInputField";
import Breadcrumbs from "../../common/breadcrumb/Breadcrumbs";
import { getCashbackSettlementReport , getCashbackSettlementEnquiry ,getCashbackSettlementExcelReport } from "../../api/login/Login";

const status = {
    1 :'Pending',
    2 : 'Success',
    3 : 'Failed',
    4 :'Refund',
}

const breadCrumbsTitle = {
  id: "1",
  title_1: "Bonus Tranaction Master",
  path_1: "/admin/cashback-settlement-report",
  title_2: "Cashback Settlement Report",
};

const CashbackSettleMentReport = () => {
  const param = useParams();
  const [operators, setOperators] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formKey, setFormKey] = useState(0);
  const [resetKey, setResetKey] = useState(false);
  const defaultInitialValues = {
    start_date: "",
    end_date: "",
    search: "",
    status: "",
  };
  const resetValues = {
    start_date: "",
    end_date: "",
    search: "",
    status: "",
  };
  const [initialValues, setInitialValues] = useState(defaultInitialValues);

  const handleReset = (resetForm) => {
    resetForm();
    setInitialValues(resetValues);
    setFormKey((prev) => prev + 1);
    setCurrentPage(1);
    setResetKey((pre) => !pre);
    // getDmtTxnData(0);
  };

  const handleSubmit = (values) => {
    console.log("fire");
    setCurrentPage(1);
    setInitialValues(values);
    setResetKey((pre) => !pre);
    // Add your API call here
  };

  const onChangeVal = (page) => {
    setResetKey((pre) => !pre);
    setCurrentPage(page);
  };

  const getData = async () => {
    let body = {
      ...initialValues,
      page: currentPage,
      count: 10,
    };
    let res = await getCashbackSettlementReport(body);
    setData(res?.data);
  };

    const downloadExcel = async () => {
      try {
        setLoading(true);
        const res = await getCashbackSettlementExcelReport({
          ...initialValues,
        });
  
        if (res && res.data && res.data?.trans?.length > 0) {
            const dataForExcel = res?.data?.trans.map((response, i) => (
              {
    "Sr. No": i+1,
    "Date / Time": response.createdAt,
    "Name": response.username,
    "Beneficiary Name": response.beneficiary_name,
    "Mobile Number": response.mobile,
    "Transaction ID": response.txn_id,
    "Transaction Mode": response.txn_mode,
    "IFSC Code": response.ifsc_code,
    "Bank Name": response.bank_name,
    "Account Number": response.account_number,
    "UTR": response.utr || "",
    "Updated": response.updatedAt,
    "Status Updated": response.status_update_time,
    "Amount": response.amount,
    "Charge": response.charge,
    "Opening Balance": response.o_bal,
    "Closing Balance": response.c_bal,
    "Status":
      response.status === 2
        ? "Success"
        : response.status === 1
        ? "Pending"
        : response.status === 3
        ? "Failed"
        : response.status === 4
        ? "Refund"
        : "Unknown",
    "Distributor Name": response.distributor_name || "",
    "Distributor Mobile": response.distributor_mobile || "",
    "Distributor Refer Id": response.distributor_refer_id || "",
    "Super Distributor Name": response.master_dist_name || "",
    "Super Distributor Mobile": response.master_dist_mobile || "",
    "Super Distributor Refer Id": response.master_dist_refer_id || ""
  }
            ));
  
          const ws = XLSX.utils.json_to_sheet(dataForExcel);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Cashback Report");
          XLSX.writeFile(wb, `Cashback Report ${new Date().toLocaleDateString()}.xlsx`);
        } else {
          message.error('No data available to export!');
        }
      } catch (error) {
        console.error("Error downloading Excel:", error);
        message.error('Failed to download Excel. Please try again.');
      } finally {
        setLoading(false);
      }
    };

      const responseEnquiry = async (id) => {
        setLoading(true); // Start loader before API call
        try {
            const res = await getCashbackSettlementEnquiry(id);
            if (res?.data?.statusCode == "200") {
                message.success(res?.data?.message || "Operation successful");
                
            } else if (res?.data?.statusCode == "300") {
                message.info(res?.data?.message || "Transaction requires attention");
               
            } else {
                message.error(res?.message || res?.data?.message || "Operation failed");
                
            }
        } catch (error) {
            console.error("Error in payment enquiry:", error);
            message.error("An error occurred while processing your request");
        } finally {
            setResetKey((pre)=>!pre)
            setLoading(false); 
        }
    };

  useEffect(() => {
    getData();
  }, [resetKey, currentPage]);

  console.log(data, "data");
  return (
    <>
      {loading && <Loadar />}
      <ToastContainer />

      <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />

      {/* // Filter Option // */}
      <div className="row m-4">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body p-0">
              <div className="table-responsive active-projects style-1">
                <div className="tbl-caption tbl-caption-2">
                  <h4 className="heading mb-0">
                    <b>{breadCrumbsTitle.title_2} Search</b>
                  </h4>
                </div>
                <Formik
                  key={formKey}
                  initialValues={initialValues}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {({ errors, touched, resetForm }) => (
                    <Form className="tbl-captionn">
                      <div className="row">
                        <div className="col-xl-4 mb-3">
                          <Field
                            as={CustomInputField}
                            type="date"
                            name="start_date"
                            placeholder="Start Date"
                            hasError={touched.start_date && errors.start_date}
                            errorMsg={errors.start_date}
                          />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Field
                            as={CustomInputField}
                            type="date"
                            name="end_date"
                            placeholder="End Date"
                            hasError={touched.end_date && errors.end_date}
                            errorMsg={errors.end_date}
                          />
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Field
                            as="select"
                            className="form-select"
                            name="status"
                          >
                            <option value="">Select Status</option>
                            {Object?.entries(status)?.map(([key , value ])=>
                              <option  value={key}>
                                {value}
                              </option>
                            )}
                          </Field>
                        </div>
                        <div className="col-xl-4 mb-3">
                          <Field
                            as={CustomInputField}
                            type="text"
                            name="search"
                            placeholder="Txn id / account number / mobile no"
                            hasError={touched.search && errors.search}
                            errorMsg={errors.search}
                          />
                        </div>

                        <div className="col-lg-12 col-md-12">
                          <div className="d-flex justify-content-start">
                            <button
                              className="btn btn-primary me-2"
                              type="submit"
                            >
                              <i className="fas fa-search"></i> Search
                            </button>
                            <btn
                              className="btn btn-secondary"
                              type="button"
                              onClick={() => handleReset(resetForm)}
                            >
                              <i className="fas fa-refresh"></i> Reset
                            </btn>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* // filter option end here  */}

      {/* // table section  */}
      {data?.trans?.length > 0 ? (
        <>
          <section className="ListDistributer exppdf">
            <div className="row m-4">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body p-0">
                    <div className="table-responsive active-projects style-1">
                      <div className="tbl-caption">
                        <h4 className="heading mb-0">
                          <b>{breadCrumbsTitle.title_2} List</b>
                        </h4>
                        <div className="d-flex">
                          <button
                            onClick={downloadExcel}
                            className="btn btn-primary border border-white"
                          >
                            {" "}
                            <DownloadOutlined /> Download Excel
                          </button>
                        </div>
                      </div>
                         <div className="p-3">
                                    <h3 className="totalAmountstyle">Total Amount: <b>{data?.totalAmount || 0}</b></h3>
                                </div>
                      <div
                        id="empoloyees-tblwrapper_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="table-to-xls"
                          className="table dataTable no-footer"
                          role="grid"
                          aria-describedby="empoloyees-tblwrapper_info"
                        >
                          <thead>
                            <tr role="row">
                              <th>Sr. No</th>
                              <th>Date / Time</th>
                              <th>Name</th>

                              <th>Retailer Mobile No</th>
                              <th>Bank Name</th>
                              <th>IFSC Code</th>
                              <th>Account Number</th>
                              <th>Transaction ID</th>
                              <th>UTR Number</th>

                              <th>Updated</th>
                              <th>Status Updated</th>

                              <th>Opening Balance</th>
                              <th>Amount</th>
                              <th>Charges</th>
                              <th>Closeing Balance</th>
                              <th>Status</th>

                              <th>Distributor Name</th>
                              {/* <th>Distributor Commission</th> */}
                              <th>Super Distributor Name</th>
                              {/* <th>Super Distributor Commission</th> */}
                              <th>Distributor Contact</th>
                              <th>Super Distributor Contact</th>
                              <th>Distributor Refer Id</th>
                              <th>Super Distributor Refer Id</th>
                              <th>Enquiry Log</th>
                              <th>Enquiry</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.trans?.map((item, i) => (
                              <tr key={i} role="row" className="odd">
                                <td>{i + 1}</td>
                                <td>{item?.createdAt}</td>
                                <td>{item?.username}</td>
                                <td>{item?.mobile}</td>
                                <td>{item?.bank_name}</td>
                                <td>{item?.ifsc_code}</td>
                                <td>{item?.account_number}</td>
                                <td>{item?.txn_id}</td>
                                <td>{item?.utr}</td>

                                <td>{item?.updatedAt}</td>
                                <td>{item?.status_update_time}</td>

                                <td>{item?.o_bal}</td>
                                <td>{item?.amount}</td>
                                <td>{item?.charge}</td>
                                <td>{item?.c_bal}</td>
                                <td>
                                  {item?.status === 1 && (
                                    <button className="btn btn-warning">
                                      Pending
                                    </button>
                                  )}
                                  {item?.status === 2 && (
                                    <button className="btn btn-success">
                                      Success
                                    </button>
                                  )}
                                  {item?.status === 3 && (
                                    <button className="btn btn-danger">
                                      Failed
                                    </button>
                                  )}
                                  {item?.status === 4 && (
                                    <button className="btn btn-light">
                                      Refund
                                    </button>
                                  )}
                                </td>
                                <td>{item?.distributor_name || ""}</td>
                                {/* <td>{item?.distributor_commission || ""}</td> */}
                                <td>{item?.master_dist_name || ""}</td>
                                {/* <td>{item?.master_dist_commission || ""}</td> */}
                                <td>{item?.distributor_mobile || ""}</td>
                                <td>{item?.master_dist_mobile || ""}</td>
                                <td>{item?.distributor_refer_id || ""}</td>
                                <td>{item?.master_dist_refer_id || ""}</td>
                                <td> {item?.enqNumLog}</td>
                                <td>
                                  <Button
                                    variant="outline-primary"
                                    onClick={() => responseEnquiry(item._id)}
                                    disabled={loading || item?.status !== 1}
                                  >
                                    Enquiry
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        className="dataTables_info"
                        id="empoloyees-tblwrapper_info"
                        role="status"
                        aria-live="polite"
                      >
                        Total {data?.total} entries
                      </div>
                      <div
                        className="dataTables_paginate paging_simple_numbers"
                        id="empoloyees-tblwrapper_paginate"
                      >
                        <Pagination
                          /* showSizeChanger
                                            onShowSizeChange={''} */

                          // defaultCurrent={1}
                          // onChange={onChangeVal}
                          total={data?.total}
                          current={currentPage}
                          onChange={onChangeVal}
                        />
                      </div>
                    </div>
                  </div>
                 
                </div>
              </div>
            </div>
          </section>
        </>
      ) : (
        <div className="text-center mt-4">
          <h3>No data available</h3>
        </div>
      )}
      {/* // table section  */}
    </>
  );
};

export default CashbackSettleMentReport;
